module.exports = __webpack_public_path__ + "img/58.b806fe77.png";